import { Metamodel } from '../base/model';
import { Dataset } from './dataset';
import { Owned } from '../base/named';
import { Location } from './location/location';
import { LinkedService } from '../linkedservice/linkedservice';
import { RootFolderType } from '../linkedservice/lakehouse.linkedservice';
import { AzureBlobStorageLinkedService } from '../linkedservice/azure-blob-storage.linkedservice';
import { AzureBlobStorageLocation } from './location/azure-blob.location';

@Metamodel.model({
    abstract: true
})
export class FormatDatasetV2 extends Dataset {
    @Metamodel.attribute({
        type: Location.MODEL
    })
    public location: Location;

    public readonly isV2: boolean = true;

    public rootFolder?: RootFolderType = 'Tables'; // used by lakehouse in Trident

    public updateLinkedService(
        linkedService: LinkedService,
        originalLocation?: Location,
        options: { linkedServiceType?: string } = {}
    ): void {
        const { linkedServiceType } = options;
        this.linkedService = linkedService;
        if (this.linkedService == null) {
            this.location = null;
            return;
        }
        const locationModel = Metamodel.models().find(
            (model) =>
                Location.MODEL.isAncestor(model) &&
                model.tag('linkedServiceModel') ===
                    (linkedServiceType
                        ? Metamodel.modelByName(linkedServiceType)
                        : Metamodel.modelOf(this.linkedService))
        );
        if (locationModel != null) {
            if (this.location == null || locationModel !== Metamodel.modelOf(this.location)) {
                const newLoc = Owned.create<Location>(locationModel, this);
                const oldLocation = this.location || originalLocation;
                if (oldLocation != null) {
                    newLoc.setParameterizedLocation(oldLocation.getParameterizedLocation());
                }
                this.location = newLoc;
            }
            let containerNameInLs;
            if (
                this.location &&
                linkedService instanceof AzureBlobStorageLinkedService &&
                this.location instanceof AzureBlobStorageLocation &&
                (containerNameInLs = linkedService.getContainerNameInUri())
            ) {
                this.location.container = containerNameInLs;
            }
        } else {
            this.location = null;
        }
    }
}
